import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import DeleteIcon from '@material-ui/icons/Delete';
import { useCallback } from 'react';
import { Field } from 'react-final-form';
import { Element } from 'react-scroll';
import { propBool, propShape, propNumber, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SeminarOneFormDateField from './SeminarOneFormDateField';
const SeminarOneFormDatesFieldArrayInner = (props) => {
    const { className, datepickerProps, disabled, fields: { length, remove, value }, index, name, validates, } = props;
    /**
     * 日時削除クリック時のイベント
     * @type {(function())|*}
     */
    const onClickDelete = useCallback(() => {
        remove(index);
    }, [remove, index]);
    const { endDate, startDate } = value[index] || {};
    return (_jsx(Element, Object.assign({ className: className, name: `${name}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_dates_inner' }, { children: [_jsxs("div", Object.assign({ className: 'inner_left' }, { children: [_jsxs("div", Object.assign({ className: 'row_column' }, { children: [_jsx("div", Object.assign({ className: 'column_title' }, { children: "\u958B\u59CB\u65E5\u6642" })), _jsx(Field, { className: 'column_date', component: SeminarOneFormDateField, disabled: disabled, inputClassName: 'date_field', minDate: startDate ? undefined : datepickerProps.minDate, name: `${name}.startDate`, popperPlacement: 'bottom', validate: validates.startDate })] })), _jsxs("div", Object.assign({ className: 'row_column' }, { children: [_jsx("div", Object.assign({ className: 'column_title' }, { children: "\u7D42\u4E86\u65E5\u6642" })), _jsx(Field, { className: 'column_date', component: SeminarOneFormDateField, disabled: disabled, inputClassName: 'date_field', minDate: endDate ? undefined : datepickerProps.minDate, name: `${name}.endDate`, popperPlacement: 'bottom', validate: validates.endDate })] }))] })), length > 1 && (_jsx("div", Object.assign({ className: 'inner_right' }, { children: _jsx("button", Object.assign({ className: 'dates_delete', disabled: disabled || disabled, onClick: onClickDelete, type: 'button' }, { children: _jsx(DeleteIcon, { className: 'delete_svg' }) })) })))] })) })));
};
SeminarOneFormDatesFieldArrayInner.propTypes = {
    className: propStr(),
    datepickerProps: propShape().isRequired,
    disabled: propBool().isRequired,
    fields: propShape().isRequired,
    index: propNumber().isRequired,
    name: propStr().isRequired,
    validates: propShape().isRequired,
};
SeminarOneFormDatesFieldArrayInner.defaultProps = {
    className: '',
};
export default SeminarOneFormDatesFieldArrayInner;
